import { gql } from '@/modes/waterSupplier/gql';

export const GET_HAZARD_SURVEY_JOB = gql(`
  query HazardSurveyJob($where: JSON) {
    jobs(where: $where) {
      id
      scheduled
      waterHazardSurvey(required: true) {
        jobId
        waterService(required: true) {
          id
          siteNumber
          meterNumber
          hazardSite {
            id
            name
            siteNumber
          }
          meterSize
          address {
            id
            street1
            street2
          }
          backflowAssemblies {
            id
            model {
              name
              backflowAssemblyMake {
                name
              }
            }
            size
            serialNumber
            testAnniversary
            lastTestDate
            lastTest {
              jobId
              initialResult
              finalResult
            }
            status
            testStatus
            location
            type
            hazardType
            hazardLevel
          }
        }
        items {
          waterHazard {
            id
            name
            hazardLevel
          }
        }
        contactProfileId
        contact {
          id
          type
          name
          firstName
          lastName
          phones {
            id
            subType
            value
            extension
          }
          emails {
            id
            subType
            value
          }
        }
        instructions
        otherHazardsQuestion
        allProtectedQuestion
        items {
          surveyId
          waterHazardId
          displayOrder
          waterHazard {
            id
            name
            description
            hazardLevel
          }
        }
      }
      outboundAssignment {
        id
        vendorProfile {
          id
          name
        }
      }
      address {
        id
        street1
        street2
        city
        state
        zip
        zipExt
      }
      formData
      attachments {
        id
        type
        contentType
        url
        thumb(size: 500)
        profile {
          id
          name
        }
        created
      }
      comments {
        id
        type
        comment
        profile {
          id
          name
        }
        created
      }
      statusChanges {
        id
        fromStatus
        toStatus
        profile {
          id
          name
        }
        created
      }
    }
  }
`);

export const UPDATE_HAZARD_SURVEY = gql(`
  mutation UpdateHazardSurvey($jobId: ID!, $input: WaterHazardSurveyInput!) {
    updateWaterHazardSurvey(jobId: $jobId, input: $input) {
      jobId
    }
  }
`);

export const ASSIGN_JOB = gql(`
  mutation AssignJob($jobId: ID!, $vendorProfileId: ID!) {
    assignJob(jobId: $jobId, vendorProfileId: $vendorProfileId) {
      id
      outboundAssignment {
        id
        vendorProfile {
          id
          name
        }
      }
    }
  }
`);

export const SCHEDULE_JOB = gql(`
  mutation ScheduleJob($jobId: ID!, $scheduled: String) {
    scheduleJob(jobId: $jobId, scheduled: $scheduled) {
      id
      scheduled
    }
  }
`);

export const CREATE_HAZARD_SURVEY = gql(`
  mutation CreateHazardSurvey(
    $waterServiceId: ID!
    $input: WaterHazardSurveyInput!
  ) {
    createWaterHazardSurvey(waterServiceId: $waterServiceId, input: $input) {
      jobId
      waterServiceId
      contactProfileId
      job {
        id
        addressId
      }
    }
  }
`);
